import { apolloClient } from './apollo/apolloClient';
import { ILanguageOption } from './components/localization/LanguageContext';
import { fetchLanguageOptions } from './components/localization/storyblokClient';
import { initConfigs } from './configs';
import { CURRENCIES } from './queries/currency/currencyTypeDefs';
import { IP_ADDRESS_INFO } from './queries/ip/IPTypeDefs';
import { PARTNER_CONFIGS } from './queries/partnerConfigs/partnerConfigsTypeDefs';
import { TRANSLATIONS } from './queries/translations/translationsTypeDefs';
import { getDefaultLanguage } from './utils/utils';

(async () => {
  apolloClient.query({ query: IP_ADDRESS_INFO, fetchPolicy: 'cache-first' });
  apolloClient.query({ query: CURRENCIES, fetchPolicy: 'cache-first' });

  (async () => {
    const params = new URLSearchParams(window.location.search);
    const domain = params.get('partner') || window.runtime_env.REACT_APP_PARTNER_DOMAIN || process.env.REACT_APP_PARTNER_DOMAIN || window.location.hostname;
    await apolloClient.query({ query: PARTNER_CONFIGS, fetchPolicy: 'cache-first', variables: { domain } });
  })();

  (async () => {
    await initConfigs();
    const options = await fetchLanguageOptions() as ILanguageOption[] | undefined;
    if (options) {
      const defaultLang = getDefaultLanguage(options);
      const currentLang = defaultLang.split('-')[0];
      await apolloClient.query({
        query: TRANSLATIONS,
        fetchPolicy: 'cache-first',
        variables: {
          app: 'booking-tool',
          lng: currentLang,
        },
      });
    }
  })();
})();

import('./index');
